import { __rest } from '../../node_modules/tslib/tslib.es6.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import Dropdown from '../Dropdown/Dropdown.js';

/**
Il componente NavDropDown è una variante della comune dropdown pensata per essere utilizzata all'interno della navigazione.
Il suo funzionamento è identico a quello della dropdown eccetto per lo stile di default applicato.
 */
const NavDropdown = function NavDropdown(_a) {
    var { subtitle = '', title = '' } = _a, others = __rest(_a, ["subtitle", "title"]);
    return (jsx(Dropdown, Object.assign({}, others, { classPrefix: "navDropDown", toggleComponent: (jsxs("button", { className: "navDropDown--toggle", type: "button", children: [jsx("span", { className: "navDropDown__caret" }), jsxs("div", { className: "navDropDown__texts", children: [jsx("span", { className: "navDropDown__title", children: title }), jsx("span", { className: "navDropDown__subtitle", children: subtitle })] })] })) })));
};
NavDropdown.Item = Dropdown.Item;
NavDropdown.SubMenu = Dropdown.SubMenu;

export { NavDropdown as default };
